import { useApiModel } from '@hooks/use-api-model';
import { DashRegistrationStep, DonorDashboardStep } from '@/types/dashboard';
import type { IDashboardModel } from '@/types/dashboard';

const DASHBOARD_ENDPOINT = '/api/register/donor-dashboard';

const defaultDashboardModel: IDashboardModel = {
    id: 0,
    editKey: '',
    centerId: 0,
    organType: 0,
    currentRegistrationStep: DashRegistrationStep.GetStarted,
    isOptedOut: false,
    isRuledOut: false,
    isAutoRuleOut: false,
    isManualRuleOut: false,
    offerRuleOutTransfer: false,
    ruleOutReasons: [],
    centerName: '',
    currentStep: DonorDashboardStep.ScreeningQuestions,
    canSelectCenter: false,
    canSelectPreferredCenter: false,
    useLegacyCenterSelect: true,
    hasPwl: false,
    isFiveStar: false,
    isOptedInForSurveys: false,
    offerToConnectToDonor: false,
    languageData: {},
    isNkrDcn: false,
    isFemale: false,
    isLiver: false
};

export const useDashboard = (registrationId: number, editKey: string, survey?: string) => {
    const url = `${DASHBOARD_ENDPOINT}/${registrationId}/${editKey}?survey=${survey}`;

    const { model, isLoading, error } = useApiModel(url, defaultDashboardModel);

    return { model, isLoading, error };
};
